export default __webpack_public_path__ + "static/media/polaroid3.96167410.svg";